var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agreement"},[_c('p',[_c('span',[_vm._v("《用户条款》")]),_vm._v("和"),_c('span',[_vm._v("《隐私政策》")]),_vm._v("条款 ")])])
}]

export { render, staticRenderFns }